import { Link, useSearchParams } from 'react-router-dom';

import { Button, Typography } from '@sbv-clients/ui-shared';

import SharedAuthLayout from '../../layouts/shared-auth-layout';
import { authButtonSx } from '../../styles/auth-form.styles';

export const SharedAuthSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const action = searchParams.get('action');

  const title =
    action === 'register' ? 'Registration successful' : 'Password reset';

  return (
    <SharedAuthLayout isCheckIcon>
      <Typography variant="h1" textAlign="center" mb={8}>
        {title}
      </Typography>
      <Typography textAlign="center">
        You can now log in with your updated password to SBV Time and Attendance
        for Healthcare software
      </Typography>
      <Button
        component={Link}
        to="/auth/sign-in"
        fullWidth
        variant="contained"
        size="large"
        sx={{ ...authButtonSx, mt: '24px' }}
      >
        Go to sign in
      </Button>
    </SharedAuthLayout>
  );
};
